import React, {useState} from 'react';
import './IfYouHaveQuestions.css';
import IfYouHaveQuestionsNoActive from "../../../static/img/IfYouHaveQuestions/pfFeedback.svg";
import IfYouHaveQuestionsTop from "../../../static/img/IfYouHaveQuestions/IfYouHaveQuestionsTopNew.svg";
import IfYouHaveQuestionsSuccess from "../../../static/img/IfYouHaveQuestions/Feedback02.svg";
import axios from "axios";
let reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{1,4})$/;
const PRERENDER_TEXTS = require("../../../../prerender_base.js");


function IfYouHaveQuestions (props){
    const [status, setstatus] = useState('NoActive');
    const [eMailValue, seteMailValue] = useState('');
    const [TextValue, setTextValue] = useState('');
    const [eMailError, seteMailError] = useState('');
    const [TextValueError, setTextValueError] = useState('');
    // const [eMailErrorVisible, seteMailErrorVisible] = useState('');
    // const [TextErrorVisible, setTextErrorVisible] = useState('');
    const [TraderFeedbackMainInVisible, setTraderFeedbackMainInVisible] = useState('');
    const [TraderFeedbackSuccessVisible, setTraderFeedbackSuccessVisible] = useState("StandartNotVisible");

    // function NewMessage() {
    //     setTraderFeedbackMainInVisible("TraderFeedbackSuccessVisible");
    //     setTraderFeedbackSuccessVisible('StandartNotVisible');
    // }

    function ChangeStatus() {
        if (status === 'NoActive') {setstatus('Active');}
        else {setstatus('NoActive');}
    }

    function ChangeElement (event) {setTextValue(event.target.value);
        if (TextValue !== '') {setTextValueError("");}}

    function handleMailChange(event) {
        seteMailValue(event.target.value);
        if(reg.test(eMailValue) === true)  {seteMailError("");
            event.preventDefault();
        }
    }

    function handleSubmit(e) {
        if(reg.test(eMailValue) === false)  {seteMailError( "PersonalPageInputError");e.preventDefault();}  else {seteMailError("");}
        if (reg.test(eMailValue) && (TextValue !== '')) {
            e.preventDefault();
            let SubjectMail = 'From Site Question!';
            let output = TextValue  + ' ' + eMailValue;
            let data = {SubjectMail, output};
            console.log('Subject333', data)
            axios
                .post('https://newadmin.profiforex.com/send', data)
                .then(() => {
                        //console.log('Mail Created');
                        setTraderFeedbackMainInVisible("isNoVisible");
                        setTraderFeedbackSuccessVisible("TraderFeedbackSuccessVisible");
                    }
                )
                .catch(e => console.log('err48', e));
        }
    }

    // function handleSubmit(e) {
    //     //console.log('handleSubmit');
    //     if(reg.test(eMailValue) === false)  {seteMailError("PersonalPageInputError");
    //         e.preventDefault();
    //     }
    //     else {seteMailError("")}
    //     if(TextValue === '')  {setTextValueError("PersonalPageInputError");
    //         e.preventDefault();
    //     }
    //     if (reg.test(eMailValue) && (TextValue !== '')) {
    //         e.preventDefault();
    //         let SubjectMail = 'From Site Question!';
    //         let output = TextValue  + ' ' + eMailValue;
    //
    //         let data = {SubjectMail, output};
    //         console.log('Subject333', data)
    //
    //         axios
    //             .post('https://newadmin.profiforex.com/send', data)
    //             .then(() => {
    //                 setTraderFeedbackMainInVisible("StandartNotVisible");
    //                 setTraderFeedbackSuccessVisible('TraderFeedbackSuccessVisible');
    //                 }
    //             )
    //             .catch(e => console.log(e));
    //     }
    // }

     function TextSource(info) {
            try {return <>{JSON.parse(PRERENDER_TEXTS['IfYouHaveQuestions'][info.ArrIndex])[props.lang] ? JSON.parse(PRERENDER_TEXTS['IfYouHaveQuestions'][info.ArrIndex])[props.lang] : '*'+info.children}</>}
            catch (err) {return <>*{info.children}</>}
        }
        //console.log('8888888',AllPageText);
        //console.log('111111',props.lang);

        if (status === 'Active') {return (
        <div className="IfYouHaveQuestionsActiveOut">
            <div className="IfYouHaveQuestionsAllBlack" onClick={() => ChangeStatus()} role="button" tabIndex={0}> </div>
        <div className="IfYouHaveQuestionsActive">

        <div className="IfYouHaveQuestionsActiveIn">
            <div className="IfYouHaveQuestionsTop">
                <div className="IfYouHaveQuestionsTopTitle"><TextSource ArrIndex= 'IfYouHaveQuestions0000'>Задать вопрос специалистам</TextSource></div>
            </div>
                <div className={"TraderFeedbackMainIn " + TraderFeedbackMainInVisible}>
                    <form  onSubmit={handleSubmit}>
                        <div  className={"PersonalPageInput " + TextValueError}>
                            <label>
                                <div  className={"PersonalPageInputText"}>
                                    <div className="IfYouHaveQuestionsActiveTextareaText" ><TextSource ArrIndex= 'IfYouHaveQuestions0005'>YOUR QUESTION</TextSource></div>
                                    {/*<span className="TextPlaceHolder">Сообщения</span>*/}

                                </div>
                                <textarea className="IfYouHaveQuestionsTextarea" rows='4' value={TextValue ? TextValue : ''} name="TextValue"  onChange={ChangeElement} placeholder="&nbsp;"/>
                                <div className={"PersonalPageInputErrorText"}>
                                    {/*<img alt='alt' src={IfYouHaveQuestionsError} width='10px' height='9px'/>*/}
                                    {/*<img alt='alt' src={IfYouHaveQuestionsError2} width='15px' height='1px'/>*/}
                                    <TextSource ArrIndex= 'IfYouHaveQuestions0010'>Необходимо заполнить</TextSource></div>
                            </label>
                        </div>
                        <div  className={"PersonalPageInput PersonalPageInput02 " + eMailError}>
                            <label>
                                <div className="IfYouHaveQuestionsActiveInputText" ><TextSource ArrIndex= 'IfYouHaveQuestions0015'>YOUR E-MAIL</TextSource></div>
                                <input className="IfYouHaveQuestionsActiveInput" type="text" value={eMailValue ? eMailValue : ''} name="eMailValue"  onChange={handleMailChange} placeholder="&nbsp;"/>
                                <div className={"PersonalPageInputErrorText"}>
                                    {/*<img alt='alt' src={IfYouHaveQuestionsError} width='10px' height='9px'/>*/}
                                    {/*<img alt='alt' src={IfYouHaveQuestionsError2} width='15px' height='1px'/>*/}
                                    <TextSource ArrIndex= 'IfYouHaveQuestions0020'>Ошибка в электронной почте</TextSource></div>
                            </label>
                        </div>


                        <div className="IfYouHaveQuestionsBottom">

                        <button className={"ButtonOut IfYouHaveQuestionsButtonOut"} type="submit">
                                <div className="Button3D"><TextSource ArrIndex= 'IfYouHaveQuestions0025'>Отправить</TextSource> </div>
                            </button>
                        <div className="IfYouHaveQuestionsTopExit"  role="button" tabIndex={0} onClick={() => ChangeStatus()}><TextSource ArrIndex= 'IfYouHaveQuestions0030'>CLOSE</TextSource><img alt='alt' src={IfYouHaveQuestionsTop} width='16px' height='16px'/></div>
                        </div>
                    </form>
                </div>
                <div className={"TraderFeedbackSuccess " + TraderFeedbackSuccessVisible}>
                    <img alt='alt' src={IfYouHaveQuestionsSuccess} height='34px'/>
                    <div className="TraderFeedbackSuccessTitle"><TextSource ArrIndex= 'IfYouHaveQuestions0035'>Ваше сообщение отправлено</TextSource> </div>
                    {/*<div className="TraderFeedbackSuccessText">В ближайшее время наши сотрудники свяжутся с Вами</div>*/}
                    {/*<div className="TraderFeedbackSuccessText TraderFeedbackSuccessTextBlue"  onClick={() => NewMessage()}>Отправить еще сообщение</div>*/}
                </div>

        </div>
        </div>
        </div>

        )}
    else return (
            <div className="IfYouHaveQuestions"><img alt='alt' src={IfYouHaveQuestionsNoActive} width='47px' height='35px'/>
                <div className="IfYouHaveQuestionsText">
                    <TextSource ArrIndex= 'IfYouHaveQuestions0040'>Есть вопросы</TextSource>
                 <div className="IfYouHaveQuestionsTextLink"  onClick={() => ChangeStatus()} role="button" tabIndex={0}> <span className="IfYouHaveQuestionsTextLinkLine">— </span>
                     <span className="IfYouHaveQuestionsTextLinkText" ><TextSource ArrIndex= 'IfYouHaveQuestions0045'>задайте</TextSource></span></div>
                </div>

            </div>
        )

    }

export default IfYouHaveQuestions